export const partnersReg = {
  seo: {
    title: "Partner Regisztráció - Bespire",
    description: "Csatlakozzon a Bespire partner hálózatához és építsünk együtt egy erősebb alkotói ökoszisztémát!",
    keywords: "partner regisztráció, partnerség jelentkezés, Bespire partnerek, alkotói platform"
  },
  navigation: {
    back: "Vissza"
  },
  hero: {
    title: "Partner Regisztráció",
    description: "Csatlakozzon a Bespire partner hálózatához és építsünk együtt egy erősebb alkotói ökoszisztémát!"
  },
  form: {
    title: "Partner Jelentkezési Űrlap",
    description: "Kérjük, töltse ki az alábbi űrlapot a lehető legpontosabban",
    
    companyInfo: {
      title: "Céginformációk",
      companyName: {
        label: "Cég neve",
        placeholder: "pl. Kreatív Stúdió Kft."
      },
      website: {
        label: "Weboldal",
        placeholder: "https://www.cegem.hu"
      },
      companyDescription: {
        label: "Cég leírása",
        placeholder: "Rövid leírás a cégéről, fő tevékenységéről..."
      }
    },
    
    contactInfo: {
      title: "Kapcsolattartó adatok",
      contactPerson: {
        label: "Kapcsolattartó neve",
        placeholder: "Kovács János"
      },
      position: {
        label: "Pozíció/Munkakör",
        placeholder: "Válassza ki pozícióját",
        options: {
          tulajdonos: "Tulajdonos",
          ugyvezeto: "Ügyvezető",
          ertekesitesiVezeto: "Értékesítési vezető",
          marketingVezeto: "Marketing vezető",
          uzletfejlesztesiVezeto: "Üzletfejlesztési vezető",
          termekMenedzser: "Termék menedzser",
          projektMenedzser: "Projekt menedzser",
          ertekesitesiKepviselo: "Értékesítési képviselő",
          marketingSzakerto: "Marketing szakértő",
          ugyfelKapcsolatiMenedzser: "Ügyfél kapcsolati menedzser",
          egyeb: "Egyéb"
        }
      },
      email: {
        label: "E-mail cím",
        placeholder: "janos@cegem.hu"
      },
      phone: {
        label: "Telefonszám",
        placeholder: "+36 30 123 4567"
      }
    },
    
    partnershipDetails: {
      title: "Partnerség részletei",
      serviceType: {
        label: "Szolgáltatás típusa",
        placeholder: "Válasszon szolgáltatást",
        options: {
          webDesign: "Webdesign",
          marketing: "Marketing",
          consulting: "Tanácsadás",
          development: "Fejlesztés",
          content: "Tartalomgyártás",
          training: "Képzés"
        }
      },
      experience: {
        label: "Tapasztalat (években)",
        placeholder: "Válassza ki",
        options: {
          "1-2": "1-2 év",
          "3-5": "3-5 év",
          "6-10": "6-10 év",
          "10+": "10+ év"
        }
      },
      expectedVolume: {
        label: "Várható havi volumen",
        placeholder: "Válassza ki",
        options: {
          "1-5": "1-5 ügyfél",
          "6-15": "6-15 ügyfél",
          "16-30": "16-30 ügyfél",
          "30+": "30+ ügyfél"
        }
      },
      previousClients: {
        label: "Korábbi ügyfelek/referenciák",
        placeholder: "Röviden írja le korábbi projektjeit, ügyfeleit..."
      }
    },
    
    terms: {
      accept: "Elfogadom a",
      generalTerms: "Általános Szerződési Feltételeket",
      and: "és az",
      privacyPolicy: "Adatvédelmi Szabályzatot",
      required: "*"
    },
    
    submit: {
      button: "Jelentkezés elküldése",
      submitting: "Küldés..."
    },
    
    validation: {
      termsRequired: "Kérjük, fogadja el a feltételeket a folytatáshoz!"
    },
    
    messages: {
      success: "Sikeres jelentkezés! Hamarosan felvesszük Önnel a kapcsolatot!",
      error: "Hiba történt a jelentkezés során. Kérjük, próbálja újra!",
      termsComingSoon: "Feltételek és Adatvédelmi szabályzat hamarosan elérhető!",
      privacyComingSoon: "Adatvédelmi szabályzat hamarosan elérhető!"
    }
  }
};